import "./index.css";
import "./App.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Route, Routes } from 'react-router-dom'
import { Rotas } from './utils/Rotas'
import { UserContext } from './context/UserContext'
import React from 'react'
import Login from './components/Login'
import Layout from './pages/Layout'

function App() {
    const { user } = React.useContext(UserContext)
    console.log('user', user?.login)

    return (
        <div className="App">
            <Routes>
                {user?.login === 'true' ? (
                    <Route path="/" element={<Layout />}>
                        {Rotas.filter(
                            (item) => item.tipoUser === user.user?.role
                        ).map((item, index) => {
                            return (
                                <Route
                                    key={index}
                                    path={item.link}
                                    element={item.element}
                                />
                            )
                        })}
                    </Route>
                ) : (
                    <>
                        <Route path="*" element={<Login />}></Route>
                    </>
                )}
            </Routes>
        </div>
    )
}




export default App;
